import { render, staticRenderFns } from "./organizationIndex.vue?vue&type=template&id=38382447&scoped=true&"
import script from "./organizationIndex.js?vue&type=script&lang=js&"
export * from "./organizationIndex.js?vue&type=script&lang=js&"
import style0 from "./organizationIndex.vue?vue&type=style&index=0&id=38382447&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38382447",
  null
  
)

export default component.exports